import * as tf from '@tensorflow/tfjs';
import JSZip from 'jszip'

export async function save(model, metadata) {
    let modelData = null
    await model.save(tf.io.withSaveHandler(artifacts => {
        modelData = artifacts;
    }));

    let modelTopology = {
        modelTopology: modelData.modelTopology,
        format: modelData.format,
        generatedBy: modelData.generatedBy,
        convertedBy: modelData.convertedBy,
        weightsManifest: [{paths:["./weights.bin"], weights: modelData.weightSpecs}],
    }

    const modelTopologyBlob = new Blob([JSON.stringify(modelTopology)], { type: 'text/plant' });
    const weightsBlob = new Blob([modelData.weightData], { type: 'application/octet-stream' });
    const metadataBlob = new Blob([JSON.stringify(metadata)], { type: 'text/plant' });

    const zip = new JSZip();
    zip.file('model.json', modelTopologyBlob)
    zip.file('weights.bin', weightsBlob)
    zip.file('metadata.json', metadataBlob)

    const blob = await zip.generateAsync({type:"blob"})
    return {blob: blob, files: {model: modelTopologyBlob, weights: weightsBlob, metadata: metadataBlob}}
}